import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { CopyService } from '@amfam/shared/utility/shared-services';

import { EquipmentModel, EquipmentOption } from '../models/equipment.model';

@Component({
  selector: 'ds-equipment-selection-list',
  templateUrl: './equipment-selection-list.component.html',
  styleUrls: ['./equipment-selection-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EquipmentSelectionListComponent implements OnInit {
  @Input() equipmentList: EquipmentModel[];
  @Input() equipmentChecklist: EquipmentOption[];
  @Input() form: UntypedFormGroup;

  @Output() optionsUpdateEvent = new EventEmitter();
  @Output() checklistUpdateEvent = new EventEmitter();

  @Output() checklistCategoryUpdateEvent = new EventEmitter();
  @Input() categoryform: UntypedFormGroup;
  @Input() state: string;

  equipmentSelected: EquipmentOption[];
  newVehicleFeatureAntiTheftText = this.copyService.getCopy(
    'policy.newVehicleFeatureAntiTheftText'
  );
  antiTheftCaption = this.copyService.getCopy('policy.newVehicleFeatureAntiTheftCaption');
  antiTheftName = this.copyService.getCopy('policy.newVehicleFeatureAntiTheftDeviceText');

  constructor(private copyService: CopyService) {}

  ngOnInit(): void {
    this.form = this.buildControls(this.form, this.equipmentChecklist);
  }

  optionUpdated(update: EquipmentModel) {
    this.optionsUpdateEvent.emit(update);
  }

  handleCheckBoxCategoryInteraction(event) {
    this.checklistCategoryUpdateEvent.emit(event);
  }

  checklistUpdated(update: EquipmentOption) {
    this.equipmentChecklist.forEach(item => {
      if (item.optionName === update.optionName) {
        item.selectedOption = update.selectedOption;
      }
    });
    this.checklistUpdateEvent.emit(update);
  }

  /**
   * @author: Abhishek Singh
   * @param form : Takes a form group and adds the new controls to the form
   * @returns FormGroup : Return the form which has the new controls and the initialized values.
   */
  private buildControls(
    form: UntypedFormGroup,
    equipmentList: EquipmentOption[]
  ): UntypedFormGroup {
    for (const equipment of equipmentList) {
      form.addControl(equipment.optionKey, new UntypedFormControl(''));
    }
    return form;
  }
}
